import { rem } from 'polished'
import styled from 'styled-components'

import { type ITableBannerProps } from '../TableBanner'

interface ITableBannerStyledProps {
  type: ITableBannerProps['type']
}

export const TableBannerStyled = styled.div<ITableBannerStyledProps>`
  font-size: ${rem(12)};

  padding: ${(props) => props.theme.typography.pxToRem(12)};

  background: ${(props) =>
    props.theme.colors.alert[props.type]?.background ||
    props.theme.colors.darkGreen};

  color: ${(props) =>
    props.theme.colors.alert[props.type]?.content ||
    props.theme.colors.textInverse};
`
